module.exports = __webpack_public_path__ + "static/skains-logo-65d1a1b35b00622ae8ca39dd69cc6ed1.svg";